<template>
  <div class="text-left ">
    <div class="row">

    <div class="alert col-12 alert-warning" v-if="lista.length == 0">
      <strong>Atenção!</strong> Nenhuma solicitação de recarga encontrada
    </div>

      <div v-if="lista.length != 0" class="col-12">
        <table class="table table-dark table-striped table-sm table-responsive-sm">
          <thead>
            <tr>
              <th scope="col">Data</th>
              <th scope="col">Cpf/Cnpj</th>
              <th scope="col">Tipo pagamemto</th>
              <th scope="col">Valor</th>
              <th scope="col">Total smss</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="recarga in lista" :key="recarga._id">
              <td> {{recarga.dataCriacao | datetime}} </td>
              <td> {{recarga.cpfcnpj | cpfcnpj}} </td>
              <td> {{recarga.tipoPagamento}} </td>
              <td> {{recarga.valor | money}} </td>
              <td> {{recarga.totalSmss ? recarga.totalSmss : 'ASSINATURA LZ'}} </td>
              <td >
                <span class="badge" :class="getStatus(recarga, true)">
                  {{getStatus(recarga)}}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

</template>

<script>

import jwtDecode from 'jwt-decode';
import moment from 'moment';
import SolicitaReembolso from './SolicitaReembolso';

export default {
  data() {
    return {
      lista: [],
      form: {},
      skip:0,
      limit: 12,
    }
  },
  methods: {
    reembolso(recarga) {
      this.$modal.show(
        SolicitaReembolso,
        { recarga: recarga},
        {
          adaptive: true,
          height:'auto',
          scrollable: true
        }
      )
    },
    ehReembolsavel(recarga) {
      // é reembolsavel qdo faz menos de 7 dias, o saldo no cc eh superior ao total dessa recarga e a recarga foi confirmada
      let saldoCc = this.$store.getters.getSaldo;
      if (
        (recarga.finalizado && recarga.status) && // recarga confirmada
        moment().diff(recarga.dataCriacao, 'days') <= 7 && // ate 7 dias
        saldoCc >= recarga.totalSmss &&// tem saldo no cc
        !recarga.estornada
      ) {
        return true;
      } else {
        return false;
      }
    },
    getStatus(recarga , ehClasse){
      let statusClass = 'badge-info'
      let status = 'Em andamento';

      if (recarga.finalizado == true && recarga.status == true) {
        status =  'Aprovada';
        statusClass = 'badge-success';
      } else if (recarga.finalizado == true && recarga.status == false) {
        status =  'Rejeitada';
        statusClass = 'badge-danger';
      }

      if(ehClasse) {
        return statusClass;
      } else {
        return status;
      }
    },
    async getRecargas(skip, limit){

      skip = skip ? skip : this.skip;
      limit = limit ? limit : this.limit;

      let response = await this.$http.post('/v1/recargas/minhasRecargas', {skip, limit});
      if (response.data) this.lista = response.data;
    }
  },
  async mounted() {
    this.getRecargas();
  },

};
</script>